import React from 'react'
import { Grid, Paper, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  card: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing()
  }
}))

const CardsQuantidade = ({
  quantidadeFila,
  quantidadeAnalise,
  quantidadePendeteFilial,
  quantidadePendeteMotorista
}) => {
  const classes = useStyles()

  return (
    <>
      <Grid item xs={12}>
        <Paper className={classes.card}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={3}>
              <Typography gutterBottom>Quantidade na Fila</Typography>
              <Typography variant="h5">{quantidadeFila}</Typography>
            </Grid>
            <Grid item xs={12} sm={3}>
              <Typography gutterBottom>Quantidade em Análise</Typography>
              <Typography variant="h5">{quantidadeAnalise}</Typography>
            </Grid>
            <Grid item xs={12} sm={3}>
              <Typography gutterBottom>
                Quantidade em Aguardando Liberação
              </Typography>
              <Typography variant="h5">{quantidadePendeteFilial}</Typography>
            </Grid>
            <Grid item xs={12} sm={3}>
              <Typography gutterBottom>Quantidade em Pendente</Typography>
              <Typography variant="h5">{quantidadePendeteMotorista}</Typography>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </>
  )
}

export default React.memo(CardsQuantidade)
